/**
 * Horizontal alignment options for some page blocks.
 * Per convention, name the page block's prop "alignXPreset".
 * For these styles to work, the element must be block-level (block, flex, grid).
 */
export const ALIGN_X_PRESETS = {
  left: {
    marginInlineStart: 0,
    marginInlineEnd: 'auto'
  },
  center: {
    marginInlineStart: 'auto',
    marginInlineEnd: 'auto'
  },
  right: {
    marginInlineStart: 'auto',
    marginInlineEnd: 0
  }
};
/**
 * Typography presets mapping back to our design system.
 * Use these presets instead of manually defining individual font properties.
 */
export const TYPOGRAPHY_PRESETS = {
  // Theme (user) text styles
  themeLabel: {
    fontFamily: 'var(--theme-font__font-family--paragraph)',
    fontSize: 'var(--theme-font__label--font-size)',
    lineHeight: 'var(--theme-font__label--line-height)',
    fontWeight: 'var(--theme-font__label--font-weight)'
  },
  themeParagraphMd: {
    fontFamily: 'var(--theme-font__font-family--paragraph)',
    fontSize: 'var(--theme-font__paragraph-md--font-size)',
    lineHeight: 'var(--theme-font__paragraph-md--line-height)',
    fontWeight: 'var(--theme-font__paragraph-md--font-weight)'
  },
  themeParagraphLg: {
    fontFamily: 'var(--theme-font__font-family--paragraph)',
    fontSize: 'var(--theme-font__paragraph-lg--font-size)',
    lineHeight: 'var(--theme-font__paragraph-lg--line-height)',
    fontWeight: 'var(--theme-font__paragraph-lg--font-weight)'
  },
  themeHeadingSm: {
    fontFamily: 'var(--theme-font__font-family--heading)',
    fontSize: 'var(--theme-font__heading-sm--font-size)',
    lineHeight: 'var(--theme-font__heading-sm--line-height)',
    fontWeight: 'var(--theme-font__heading-sm--font-weight)'
  },
  themeHeadingMd: {
    fontFamily: 'var(--theme-font__font-family--heading)',
    fontSize: 'var(--theme-font__heading-md--font-size)',
    lineHeight: 'var(--theme-font__heading-md--line-height)',
    fontWeight: 'var(--theme-font__heading-md--font-weight)'
  },
  themeHeadingLg: {
    fontFamily: 'var(--theme-font__font-family--heading)',
    fontSize: 'var(--theme-font__heading-lg--font-size)',
    lineHeight: 'var(--theme-font__heading-lg--line-height)',
    fontWeight: 'var(--theme-font__heading-lg--font-weight)'
  },
  themeHeadingXl: {
    fontFamily: 'var(--theme-font__font-family--heading)',
    fontSize: 'var(--theme-font__heading-xl--font-size)',
    lineHeight: 'var(--theme-font__heading-xl--line-height)',
    fontWeight: 'var(--theme-font__heading-xl--font-weight)'
  },
  // Classy text styles
  classyLabel: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__label--font-size)',
    lineHeight: 'var(--classy-font__label--line-height)',
    fontWeight: 'var(--classy-font__label--font-weight)'
  },
  classyParagraphSm: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__paragraph-sm--font-size)',
    lineHeight: 'var(--classy-font__paragraph-sm--line-height)',
    fontWeight: 'var(--classy-font__paragraph-sm--font-weight)'
  },
  classyParagraphSmBold: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__paragraph-sm-bold--font-size)',
    lineHeight: 'var(--classy-font__paragraph-sm-bold--line-height)',
    fontWeight: 'var(--classy-font__paragraph-sm-bold--font-weight)'
  },
  classyParagraphMd: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__paragraph-md--font-size)',
    lineHeight: 'var(--classy-font__paragraph-md--line-height)',
    fontWeight: 'var(--classy-font__paragraph-md--font-weight)'
  },
  classyParagraphMdBold: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__paragraph-md-bold--font-size)',
    lineHeight: 'var(--classy-font__paragraph-md-bold--line-height)',
    fontWeight: 'var(--classy-font__paragraph-md-bold--font-weight)'
  },
  classyParagraphLgBold: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__paragraph-lg-bold--font-size)',
    lineHeight: 'var(--classy-font__paragraph-lg-bold--line-height)',
    fontWeight: 'var(--classy-font__paragraph-lg-bold--font-weight)'
  },
  classyHeadingXs: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__heading-xs--font-size)',
    lineHeight: 'var(--classy-font__heading-xs--line-height)',
    fontWeight: 'var(--classy-font__heading-xs--font-weight)'
  },
  classyHeadingSm: {
    fontFamily: 'var(--theme-font__font-family--general)',
    fontSize: 'var(--classy-font__heading-sm--font-size)',
    lineHeight: 'var(--classy-font__heading-sm--line-height)',
    fontWeight: 'var(--classy-font__heading-sm--font-weight)'
  }
};